import * as React from "react";
import { DataGrid } from "@mui/x-data-grid";
import { Button, styled } from "@mui/material";
import DeleteIcon from "@mui/icons-material/Delete";
import EditIcon from "@mui/icons-material/Edit";
import { deleteClient } from "../../apiservices";
import { toast } from "react-toastify";
import { CustomToolbar } from "../categories/categoryTable";

const Btn = styled(Button)({
  textTransform: "none",
  background: "#EEF4FF",
  color: "#0be0b5",
  "&:hover": {
    color: "#000",
    background: "#0be0b5",
  },
});

export default function DataTable({
  editLedger,
  data,
  handleCheck,
  getData,
  viewLedger,
}) {
  const columns = [
    { field: "client_name", headerName: "Client Name", width: 250 },
    { field: "contact", headerName: "Mobile No#", width: 150 },
    // {
    //   field: "city_name",
    //   headerName: "City",
    //   width: 150,
    // },
    {
      field: "address",
      headerName: "Address",
      sortable: true,
      width: 200,
    },
    // {
    //   field: "opening_balance",
    //   headerName: "Opening Balance",
    //   width: 150,
    // },
    {
      field: "balance",
      headerName: "Balance",
      width: 150,
    },
    {
      field: "actions",
      headerName: "Actions",
      width: 200,
      sortable: false,
      renderCell: (params) => (
        <>
          <Btn
            sx={{ height: '30px', width: '100px', mr: '5px', padding: 0 }}
            variant="contained"
            color="primary"
            size="small"
            onClick={() => viewLedger(params.row)}>
            View Ledger
          </Btn>
          <Btn
            title="Edit"
            variant="contained"
            sx={{ width: '30px', height: '30px', minWidth: '30px', mr: '5px', padding: 0, background: "#eed202", color: "white" }}
            onClick={() => edit(params.row)}>
            <EditIcon fontSize="small" />
          </Btn>
          <Btn
            title="Delete"
            sx={{ width: '30px', height: '30px', minWidth: '30px', mr: '5px', padding: 0, background: "red", color: "white" }}
            variant="contained"
            onClick={() => deleteRow(params.row)}>
            <DeleteIcon fontSize="small" />
          </Btn>
        </>
      ),
    }
  ];

  const rows = data;
  const edit = (params) => {
    editLedger(params);
    handleCheck();
  };
  const deleteRow = async (params) => {
    /* eslint-disable no-restricted-globals */
    if(confirm(`Are you sure to delete "${params.client_name}"`)){
      let res = await deleteClient(params.id);
      if (res) {
        toast.error("Client deleted successfully");
        getData();
      }
    }
  };
  return (
    <div style={{ height: "80vh", width: "100%" }}>
      <DataGrid
        rows={rows}
        columns={columns}
        initialState={{
          pagination: {
            paginationModel: { page: 0, pageSize: 20 },
          },
        }}
        pageSizeOptions={[20, 50]}
        components={{
          Toolbar: CustomToolbar,
        }}
      />
    </div>
  );
}
